var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 51c13.807 0 25-11.193 25-25S39.807 1 26 1 1 12.193 1 26s11.193 25 25 25z",
    fill: "#14B497",
    stroke: "#14B497",
    strokeWidth: 1.777
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.113 13.605-.385 17.5h-2.66l-.385-17.5h3.43zM26.538 38.21c-.607 0-1.12-.21-1.54-.63-.42-.42-.63-.933-.63-1.54s.21-1.12.63-1.54c.42-.42.933-.63 1.54-.63.583 0 1.073.21 1.47.63.42.42.63.933.63 1.54s-.21 1.12-.63 1.54c-.397.42-.887.63-1.47.63z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.767f0c9e37b7f1ffde21389dcd4c771f.svg";
export { ForwardRef as ReactComponent };